import { Dimensions } from "react-native";
import type { Track } from "react-native-track-player";
import { create } from "zustand";

const { width: SCREEN_WIDTH, height: SCREEN_HEIGHT } = Dimensions.get("window");
const EXPANDED_PLAYER_HEIGHT = 140;
const EXPANDED_PLAYER_WIDTH = 300;
const INITIAL_PLAYER_POSITION = {
	x: SCREEN_WIDTH - EXPANDED_PLAYER_WIDTH - 16,
	y: SCREEN_HEIGHT - EXPANDED_PLAYER_HEIGHT - 80, // Initial position (approximate above tab bar)
};

export type PlayerPosition = {
	x: number;
	y: number;
};

type PodcastPlayerState = {
	visible: boolean;
	currentTrackInfo: Track | null;
	playerPosition: PlayerPosition;
	showGlobalPlayer: boolean;
	isPlaying: boolean;
	endOfQueue: boolean;
	isFirstTrack: boolean;
	setIsPlaying: (isPlaying: boolean) => void;
	setVisible: (visible: boolean) => void;
	setCurrentTrackInfo: (info: Track | null) => void;
	updatePlayerPosition: (position: PlayerPosition) => void;
	setShowGlobalPlayer: (show: boolean) => void;
	setEndOfQueue: (endOfQueue: boolean) => void;
	setIsFirstTrack: (isFirstTrack: boolean) => void;
};

export const usePodcastPlayerStore = create<PodcastPlayerState>((set) => ({
	visible: false,
	currentTrackInfo: null,
	playerPosition: INITIAL_PLAYER_POSITION,
	showGlobalPlayer: true,
	isPlaying: false,
	endOfQueue: false,
	isFirstTrack: false,
	setIsPlaying: (isPlaying) => set({ isPlaying }),
	setEndOfQueue: (endOfQueue) => set({ endOfQueue }),
	setVisible: (visible) => set({ visible }),
	setCurrentTrackInfo: (info) => set({ currentTrackInfo: info }),
	updatePlayerPosition: (position) => {
		set({ playerPosition: position });
	},
	setShowGlobalPlayer: (show) => set({ showGlobalPlayer: show }),
	setIsFirstTrack: (isFirstTrack) => set({ isFirstTrack }),
}));
